import { Autocomplete, AutocompleteProps, Chip, TextField, TextFieldProps } from "@mui/material";

// Use a more flexible type that allows boolean for disableClearable
type FlexibleAutocompleteProps<T> = Omit<
  AutocompleteProps<T, true, boolean, false>,
  "renderInput" | "renderTags"
>;

export interface StyledMultiSelectProps<T> extends FlexibleAutocompleteProps<T> {
  label?: React.ReactNode;
  helperText?: React.ReactNode;
  placeholder?: string;
  textFieldProps?: Partial<Omit<TextFieldProps, "label" | "helperText" | "placeholder" | "size">>;
  renderTags?: (value: T[], getTagProps: (params: { index: number }) => any) => React.ReactNode;
}


function StyledMultiSelect<T>({
  label,
  helperText,
  placeholder,
  textFieldProps,
  size = "small",
  renderTags,
  ...autocompleteProps
}: StyledMultiSelectProps<T>) {
  const defaultRenderTags = (value: T[], getTagProps: (params: { index: number }) => any) =>
    value.map((option, index) => {
      const { key, ...tagProps } = getTagProps({ index });
      return (
        <Chip
          key={key}
          size={size}
          variant="outlined"
          label={String(option)}
          {...tagProps}
        />
      );
    });

  return (
    <Autocomplete
      {...autocompleteProps}
      size={size}
      renderTags={renderTags || defaultRenderTags}
      renderInput={(params) => (
        <TextField
          {...params}
          {...textFieldProps}
          label={label as any}
          helperText={helperText as any}
          placeholder={placeholder}
          size={size}
        />
      )}
    />
  );
}

export default StyledMultiSelect;
